<script setup lang="ts">
/**
 * Wurzelkomponente. Sie entscheidet nur über das Layout:
 * öffentliche Seiten (Login) stehen für sich, alles andere läuft in der AppShell
 * mit Kopfzeile und Seitennavigation.
 */
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppShell from './components/AppShell.vue';
import ToastHost from './components/ToastHost.vue';
import { useAuthStore } from './stores/auth';

const route = useRoute();
const auth = useAuthStore();

const zeigeShell = computed(() => !route.meta.public && auth.isAuthenticated);
</script>

<template>
  <AppShell v-if="zeigeShell">
    <RouterView />
  </AppShell>
  <RouterView v-else />
  <ToastHost />
</template>
